import React, { Fragment, useState } from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import {
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Nav,
  NavItem,
  NavLink,
  Button,
  Label,
  Alert,
  TabContent,
  TabPane,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import Card from '../../../../components/Card/Card';

import FlowLink from '../../../../components/Flow/FlowLink';
import FlowParkedDomain from '../../../../components/Flow/FlowParkedDomain';
import FlowSubAccount from '../../../../components/Flow/FlowSubAccount/FlowSubAccount';
import FlowAgencies from '../../../../components/Flow/FlowAgencies';
import FlowAgencyBanner from '../../../../components/Flow/FlowAgencyBanner';
import FlowTitle from '../../../../components/Flow/FlowTitle';
import FlowSources from '../../../../components/Flow/FlowSources';
import FlowOffers from '../../../../components/Flow/FlowOffers';
import FlowLandingsTable from '../../../../components/Flow/FlowLandingsTable';
import FlowPostback from './FlowPostback';
import FlowTrafficback from '../../../../components/Flow/FlowTrafficback';
import FlowFailAction from '../../../../components/Flow/FlowFailAction';
import FlowTrackers from '../../../../components/Flow/FlowTrackers';
import FlowToggleBtns from '../../../../components/Flow/FlowToggleBtns';
import Hint from '../../../../components/Hint/Hint';
import AlertModal from '../../../../modals/AlertModal/AlertModal';
import DomainUrl from '../../../../components/Domains/DomainUrl';
import DomainDisclaimer from '../../../../components/Domains/DomainDisclaimer';
import OfferTopLink from '../Offer/OfferTopLink';
import IframeConstructorModal from '../../../../modals/IframeConstructorModal/IframeConstructorModal';
import CustomControl from '../../../../components/CustomControl/CustomControl';
import TransitsFeatures from '../../../../components/Flow/TransitsFeatures';
import FlowQRCode from '../../../../components/Flow/FlowQRCode';
import FlowDirectLinkHint from '../../../../components/Flow/FlowDirectLinkHint';
import { FMessage, FHTMLMessage } from '../../../../hoc/IntlComponents';
import Icon from '../../../../components/Icon/Icon';
import LandingFeaturesModal from './LandingFeaturesModal';
import TransitsFeaturesModal from './TransitsFeaturesModal';
import FlowABTestFeature from '../../../../components/Flow/FlowABTestFeature';
import FlowDirectLinkForm from '@components/Flow/FlowDirectLinkForm';
import FlowDeepLink from '../../../../components/Flow/FlowDeepLink';
import { Link } from 'react-router-dom';
import FlowWarning from '../../../../components/Flow/FlowWarning';
import DomainReplicaWarning from '../../../../components/Domains/DomainReplicaWarning';

const renderTabsControls = (tabsControls, activeTab, setActiveTab) => (
  <Nav tabs className="no-margin">
    {tabsControls.map(
      (control, index) =>
        control && (
          <NavItem key={index}>
            <NavLink
              className={cn({ active: activeTab === index + 1 })}
              onClick={() => {
                setActiveTab(index + 1);
              }}
            >
              {control}
            </NavLink>
          </NavItem>
        ),
    )}
  </Nav>
);

const dropdownItemClickHandler = (index, setActiveTab, toggleDropdown) => {
  setActiveTab(index + 1);
  toggleDropdown(false);
};

const toggleDropdownHandler = (dropdownOpen, toggleDropdown) => {
  toggleDropdown(!dropdownOpen);
};

const renderDropdown = (tabsControls, activeTab, setActiveTab, dropdownOpen, toggleDropdown) => {
  const title = tabsControls[activeTab - 1];
  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={toggleDropdownHandler.bind(null, dropdownOpen, toggleDropdown)}
      className={'nav-tabs-collapse'}
    >
      <DropdownToggle
        tag="span"
        data-toggle="dropdown"
        aria-expanded={dropdownOpen}
        className="dropdown-toggle"
      >
        {title}
      </DropdownToggle>
      <DropdownMenu>
        {tabsControls.length > 0 &&
          tabsControls.map(
            (navLink, index) =>
              navLink && (
                <DropdownItem
                  tag="span"
                  key={`flow-tabs-dropdown-${index}`}
                  onClick={dropdownItemClickHandler.bind(null, index, setActiveTab, toggleDropdown)}
                >
                  {navLink}
                </DropdownItem>
              ),
          )}
      </DropdownMenu>
    </Dropdown>
  );
};

const FlowForm = ({
  data: {
    stream,
    subAccount,
    errors,
    isClick,
    modal,
    message,
    type,
    iframeConstructorModalOpen,
    iframeConstructorSettings,
    use_transit_service,
    trackersDropdownOpen,
    isExtraSettingsOpen,
    loading,
    offers,
    sites,
    offer,
    settings,
    profile,
    isEdit,
    isCdn,
    isUserBlocked,
    site_key,
    deepLink,
    landingsABTestEnabled,
    transitsABTestEnabled,
    isUsingDirectLinkWithoutRedirectLanding,
    domainParking,
  },
  handleSubmit,
  redirectedFromOffer,
  getComputedLink,
  handleSubAccountChange,
  _alertRefs,
  handleDomainCheck,
  handleDomainChange,
  getParkingType,
  getOffersWithNoReplics,
  handleOfferChange,
  handleSiteChange,
  handleAgencyChange,
  handleRequestOfferAccess,
  handleChangeABTest,
  handleLandFeatureChange,
  sortLandingsByTotalCr,
  handleLandingChange,
  toggleIframeConstructorModal,
  handleTransitsComebackerChange,
  handleTransitFeatureChange,
  handleNewsShowcaseSettingsChange,
  handleUseTransitsChange,
  handleTransitChange,
  handlePostbackChange,
  handleStatusChange,
  handlePixelChange,
  handleTrafbackUrlChange,
  handleFailActionChange,
  handleTrackerChange,
  toggleTrackersDropdown,
  toggleModal,
  handleIframeConstructorSubmit,
  handleChange,
  setTopLink,
  handleDeepLinkChande,
  getSelectedFeaturesId,
  handleDirectLinkSubdomainChange,
  toggleDirectLinkWithoutRedirectLandingUsage,
  checkDirectLinkWithoutRedirect,
  moveIframeConstructorToEnd,
  showVkCabinetSubtext,
  handleClickVkWarningLink,
  showWarning,
  replicaOffersIds,
  domainParkingToggle,
  onDomianParkingInputChange,
}) => {
  const [activeTab, setActiveTab] = useState(1);
  const [dropdownOpen, toggleDropdown] = useState(false);

  const [landingFeaturesModalOpen, setLandingFeaturesModalOpenState] = useState(false);
  const [transitsFeaturesModalOpen, setTransitsFeaturesModalOpenState] = useState(false);

  const landingFeaturesModalToggle = () =>
    setLandingFeaturesModalOpenState(!landingFeaturesModalOpen);
  const transitsFeaturesModalToggle = () =>
    setTransitsFeaturesModalOpenState(!transitsFeaturesModalOpen);

  const tabsControls = [
    <Fragment key="flow.form.trafficback">
      <FormattedMessage id="flow.form.trafficback" defaultMessage="TrafficBack" />
      <FormattedMessage
        id="flow.form.trafficback.hint"
        defaultMessage="In this field you can specify an arbitrary URL, to which the user will be redirected if it doesn’t match the offer’s geography"
      >
        {(hint) => <Hint id="trafficback-hint" text={hint} />}
      </FormattedMessage>
    </Fragment>,
    <FormattedMessage
      key="flow.form.postback.title"
      id="flow.form.postback.title"
      defaultMessage="Postback URL"
    />,
    isCdn && settings.trackers ? (
      <Fragment key="flow.form.external-stats.title">
        <FMessage id="flow.form.external-stats.title.theme_3" />
        <Hint
          id="flow-external-stats-hint"
          text={<FHTMLMessage id="flow.form.external-stats.hint" />}
        />
      </Fragment>
    ) : null,
  ];

  const panes = [
    <Fragment key="flow.form.trafficback">
      <Card.Body>
        <Row>
          <Col lg="6">
            <FlowTrafficback
              url={stream.trafficback}
              onChangeTrafficbackUrl={handleTrafbackUrlChange}
              disabled={isUsingDirectLinkWithoutRedirectLanding || domainParking.enabled}
            />
          </Col>
        </Row>
      </Card.Body>
      <Card.Body>
        <FlowFailAction
          availableFailActions={stream.failActions}
          onChangeFailAction={handleFailActionChange}
          offers={offers.filter(({ id }) => id !== stream.offerId)}
          disabled={isUsingDirectLinkWithoutRedirectLanding || domainParking.enabled}
        />
      </Card.Body>
    </Fragment>,
    <FlowPostback
      streamId={stream.id}
      postback={stream.postback}
      streamPixels={stream.pixels}
      statuses={settings.postBackStatuses}
      streamStatuses={stream.statuses}
      pixels={offer.pixels}
      settings={settings}
      onPostbackChange={handlePostbackChange}
      onStatusChange={handleStatusChange}
      onPixelChange={handlePixelChange}
      className={cn('flow-postback-card', { isOpen: isExtraSettingsOpen })}
      key="flow.form.postback"
    />,
    isCdn && settings.trackers ? (
      <FlowTrackers
        className={cn('flow-trackers-card', { isOpen: isExtraSettingsOpen })}
        trackers={settings.trackers.tracking}
        values={stream.trackers}
        onTrackerChange={handleTrackerChange}
        readOnly={!stream.editable}
        toggleTrackersDropdown={toggleTrackersDropdown}
        trackersDropdownOpen={trackersDropdownOpen}
        key="flow.form.trackers"
      />
    ) : null,
  ];
  return (
    <Form className="flow-form" onSubmit={handleSubmit}>
      {!loading && (
        <Row>
          <Col className="create-flow-header">
            <h3>
              {isEdit ? (
                <FormattedMessage id="flow.title.edit" defaultMessage="Edit flow" />
              ) : (
                <FormattedMessage id="flow.title.create" defaultMessage="Create flow" />
              )}
            </h3>
            {!isEdit && <FlowToggleBtns />}
          </Col>
        </Row>
      )}
      <Card>
        <Card.Header>
          <FormattedMessage id="flow.form.common.title" defaultMessage="Main parameters" />
        </Card.Header>
        {isEdit && (
          <Card.Body className="no-padding">
            <Row className="flow-form-row flow-form-link">
              <Col
                xs={{ order: 1 }}
                sm={{ order: 1 }}
                md={{ order: 1 }}
                lg={{ order: 1 }}
                xl={{ order: 0, size: 8 }}
              >
                {/* Link */}
                {stream.link && !stream.directLinkLandingWithoutRedirect && (
                  <FlowLink link={getComputedLink(stream.link)} />
                )}
                {stream.directLinkLandingWithoutRedirect && (
                  <FlowLink
                    link={getComputedLink(stream.directLinkLandingWithoutRedirect, '&callsubid=')}
                    id="flow.form.direct-link-without-redirect.title"
                    defaultMessage="Direct link without redirect"
                  />
                )}
              </Col>

              <Col
                xs={{ order: 1 }}
                sm={{ order: 1 }}
                md={{ order: 1 }}
                lg={{ order: 1 }}
                xl={{ order: 1, size: 4, offset: 0 }}
              >
                {stream.editable && stream.link && (
                  <FlowQRCode link={getComputedLink(stream.link)} />
                )}
              </Col>

              {!stream.editable || showWarning ? (
                <Col
                  xs={{ order: 0 }}
                  sm={{ order: 0 }}
                  md={{ order: 0 }}
                  lg={{ order: 0 }}
                  xl={{ order: 1, size: 12 }}
                >
                  {!stream.editable ? <FlowAgencyBanner agency={stream.agency} /> : <FlowWarning />}
                </Col>
              ) : null}
            </Row>

            {/* Parked domain */}
            {settings.clickDomains && settings.clickDomains.length > 0 && (
              <Row className="flow-form-row">
                <Col xl="12">
                  <FlowParkedDomain
                    subAccount={subAccount}
                    encId={stream.encId}
                    domains={settings.clickDomains}
                  />
                </Col>
              </Row>
            )}

            <Row className="flow-form-row">
              <Col xl="12">
                {/* Direct Landing Link */}
                {stream.directLinkLanding && (
                  <FlowLink
                    id="flow.form.direct-landing-link"
                    defaultMessage="Landing Link"
                    link={getComputedLink(stream.directLinkLanding, '&callsubid=')}
                  />
                )}
              </Col>
            </Row>

            <Row className="flow-form-row">
              <Col xl="12">
                {/* Direct Prelander Link */}
                {stream.directLinkPrelander && (
                  <FlowLink
                    id="flow.form.direct-prelander-link"
                    defaultMessage="Prelander Link"
                    link={getComputedLink(stream.directLinkPrelander, '&callsubid=')}
                  />
                )}
              </Col>
            </Row>

            <Row className="flow-form-row no-border">
              <Col xl="12">
                {/* Sub Account */}
                <FlowSubAccount onSubAccountChange={handleSubAccountChange} />
              </Col>
            </Row>

            <Row className="flow-form-row">
              <Col xl="12">
                {!isCdn && (
                  <FlowDeepLink onDeepLinkChange={handleDeepLinkChande} deepLink={deepLink} />
                )}
              </Col>
            </Row>
          </Card.Body>
        )}

        <Card.Body className="no-padding">
          {/* Domain */}
          {isClick && (
            <div ref={_alertRefs.rotator_domain}>
              <Row>
                <Col className="flow-form-row" lg="12">
                  <DomainUrl
                    url={stream.rotator_domain}
                    isEdit={isEdit}
                    onCheckDomain={handleDomainCheck}
                    onUrlChange={handleDomainChange}
                    error={errors.rotator_domain}
                  />
                </Col>
                <Col lg="12">
                  <DomainDisclaimer type={type} parkingType={getParkingType()} />
                </Col>
              </Row>
            </div>
          )}
          <Row>
            <Col className="flow-form-row" lg="12">
              {/* Title */}
              <div ref={_alertRefs.title}>
                <FlowTitle title={stream.title} onChangeTitle={handleChange} error={errors.title} />
              </div>

              {/* Offers */}
              <div ref={_alertRefs.offers}>
                {isEdit ? (
                  <FormGroup className="stream-offer-select">
                    <Label htmlFor="offer_id">
                      <FormattedMessage id="flow.form.offer" defaultMessage="Offer" />
                    </Label>
                    <Input
                      type="select"
                      id="offer_id"
                      name="offer_id"
                      defaultValue={offer.id}
                      disabled
                    >
                      <option value={offer.id}>{offer.title}</option>
                    </Input>
                  </FormGroup>
                ) : redirectedFromOffer ? (
                  <FormGroup className="stream-offer-select">
                    <Label htmlFor="offer_id">
                      <FormattedMessage id="flow.form.offer" defaultMessage="Offer" />
                    </Label>
                    <Input
                      type="select"
                      id="offer_id"
                      name="offer_id"
                      defaultValue={redirectedFromOffer.id}
                      disabled
                    >
                      <option value={redirectedFromOffer.id}>{redirectedFromOffer.title}</option>
                    </Input>
                  </FormGroup>
                ) : (
                  <FlowOffers
                    className="stream-offer-select"
                    offerId={stream.offerId}
                    offers={getOffersWithNoReplics(offers)}
                    onOfferChange={handleOfferChange}
                    error={errors.offer}
                  />
                )}
                {isClick && replicaOffersIds?.length > 0 ? <DomainReplicaWarning /> : null}
              </div>
            </Col>
            <Col className="flow-form-row" lg="12">
              {/* Source */}
              <div ref={_alertRefs.site}>
                <FlowSources
                  sourceId={stream.siteId}
                  sources={sites}
                  onSiteChange={handleSiteChange}
                  error={errors.site}
                />
              </div>

              {/* Agency */}
              {!isEdit && Array.isArray(settings.agencies) && settings.agencies.length > 0 && (
                <>
                  <FlowAgencies
                    className="no-margin"
                    agency={stream.agency}
                    agencies={settings.agencies}
                    onAgencyChange={handleAgencyChange}
                    disabled={isUsingDirectLinkWithoutRedirectLanding || domainParking.enabled}
                  />
                  {showVkCabinetSubtext ? (
                    <div className="p-4">
                      <FMessage id="flow.form.agency.vk.warning" />
                      <a
                        onClick={handleClickVkWarningLink}
                        className="flow-agency-warning-link"
                        tabIndex={1}
                      >
                        <FMessage id="flow.form.agency.vk.warning.link" />
                      </a>
                    </div>
                  ) : null}
                </>
              )}
            </Col>
            {offer && isCdn && (
              <Col className="flow-form-row" lg="12">
                <FormGroup>
                  <Label className="features-label" htmlFor="features">
                    <FormattedMessage
                      id="flow.form.features.title"
                      defaultMessage="Flow specificity"
                    />
                  </Label>
                  <div className="features-controls">
                    <div className="features-controls-abtest">
                      <FlowABTestFeature
                        selected={landingsABTestEnabled || transitsABTestEnabled}
                      />
                    </div>
                    <div className="features-controls features-modals">
                      <Button
                        color="primary"
                        size="sm"
                        className="features-controls-button"
                        type="button"
                        onClick={transitsFeaturesModalToggle}
                      >
                        <Icon type="gear" />
                        <FormattedMessage
                          id="flow.prelanders.theme_3"
                          defaultMessage="Prelanders"
                        />
                      </Button>

                      <Button
                        color="primary"
                        size="sm"
                        className="features-controls-button"
                        onClick={landingFeaturesModalToggle}
                        type="button"
                      >
                        <Icon type="gear" />
                        <FormattedMessage id="flow.landings" defaultMessage="Landings" />
                      </Button>
                    </div>
                  </div>
                </FormGroup>
              </Col>
            )}
          </Row>

          {/* {offer && offer.top_bundle && (
            <OfferTopLink
              item={offer.top_bundle}
              offer={offer}
              onClick={setTopLink}
              inFlow={true}
              disabled={!!stream.agency}
              bodyControls
            />
          )}

          <Row>
            <Col xl="6" className="offer-top-link-col">
              {offer.top_bundle && (
                <OfferTopLink
                  item={offer.top_bundle}
                  offer={offer}
                  connectOffer={handleRequestOfferAccess}
                  onlyLanding
                />
              )}
            </Col>
            <Col xl="6" className="offer-top-link-col offer-top-link-prelanding">
              {offer.top_bundle && !stream.agency && (
                <OfferTopLink
                  item={offer.top_bundle}
                  offer={offer}
                  connectOffer={handleRequestOfferAccess}
                  onlyPrelanding
                />
              )}
            </Col>
          </Row> */}

          <div ref={_alertRefs.landings}>
            {errors.landings && <Alert color="danger">{errors.landings}</Alert>}
          </div>

          {/* Transits */}
          {offer.transits && offer.transits.length > 0 && !stream.agency && (
            <Card className="flow-offer-landings">
              <Card.Header className="no-padding">
                <span className="flow-offer-landings-title">
                  <FormattedMessage id="flow.prelanders.theme_3" defaultMessage="Prelanders" />
                </span>
              </Card.Header>

              <Card.Body className="no-padding">
                {profile && profile.use_transit_service === false && (
                  <div className="flow-transit-service-control">
                    <FormGroup>
                      <CustomControl
                        id="use_transit_service"
                        name="use_transit_service"
                        className="custom-control-xs"
                        onChange={handleUseTransitsChange}
                        checked={use_transit_service}
                        value="1"
                      >
                        <FormattedMessage
                          id="profile.use_transit_service"
                          defaultMessage="Enable service «1001transits for affiliates»"
                        />
                      </CustomControl>
                    </FormGroup>
                  </div>
                )}
                <fieldset
                  disabled={
                    !stream.editable ||
                    !use_transit_service ||
                    isUsingDirectLinkWithoutRedirectLanding ||
                    domainParking.enabled
                  }
                >
                  <FlowLandingsTable
                    name="transits"
                    landingsTableType="transits"
                    landings={offer.transits}
                    domains={offer.domains.transits}
                    checked={stream.transitsId}
                    checkedLandings={stream.landingsId}
                    abTestEnabled={transitsABTestEnabled}
                    abTestDisabled={
                      isUsingDirectLinkWithoutRedirectLanding || domainParking.enabled
                    }
                    onLandingChange={handleTransitChange}
                    offerId={offer.id}
                    abTest={stream.abTest}
                    multiple
                    site_key={site_key}
                    offer={offer}
                    streamId={stream.id}
                    inFlow
                  />
                </fieldset>

                <div className="transits-list-additional">
                  <ul className="list-inline no-margin">
                    <li className="list-inline-item">
                      <Button
                        type="button"
                        color="primary"
                        size="sm"
                        onClick={(e) => handleTransitChange(0, e)}
                      >
                        <FormattedMessage
                          id="flow.form.disable-prelanders.theme_3"
                          defaultMessage="Reset selection"
                        />
                      </Button>
                    </li>
                  </ul>

                  {/* <div className="transits-constructor-disclaimer">
                    <span className="transits-constructor-disclaimer-inner">
                      <FormattedMessage
                        id="flow.1001transits.disclaimer"
                        defaultMessage="Provided by 1001transits"
                        values={{
                          link: (
                            <a href="http://www.1001transits.com/" target="_blank">
                              1001transits
                            </a>
                          ),
                        }}
                      />
                    </span>
                  </div> */}
                </div>
              </Card.Body>
            </Card>
          )}

          {/* Landings */}
          {offer.landings && offer.landings.length > 0 && (
            <Card className="flow-offer-landings">
              <Card.Header className="no-padding">
                <span className="flow-offer-landings-title">
                  <FormattedMessage id="flow.landings" defaultMessage="Landings" />
                </span>
              </Card.Header>

              <Card.Body className="no-padding">
                <fieldset disabled={!stream.editable}>
                  <FlowLandingsTable
                    name="landing"
                    landingsTableType="landings"
                    landings={moveIframeConstructorToEnd(offer.landings)}
                    domains={offer.domains.landings}
                    checked={stream.landingsId}
                    checkedTransits={stream.transitsId}
                    abTestEnabled={landingsABTestEnabled}
                    abTestDisabled={
                      isUsingDirectLinkWithoutRedirectLanding || domainParking.enabled
                    }
                    onLandingChange={handleLandingChange}
                    offerId={offer.id}
                    abTest={stream.abTest}
                    toggleIframeConstructorModal={toggleIframeConstructorModal}
                    multiple
                    site_key={site_key}
                    offer={offer}
                    streamId={stream.id}
                    streamLandings={stream.landings}
                    inFlow
                  />
                </fieldset>
              </Card.Body>
            </Card>
          )}
        </Card.Body>
      </Card>

      {offer.direct_link_without_redirect && !isClick && (
        <FlowDirectLinkForm
          direct_link_without_redirect={offer.direct_link_without_redirect}
          value={stream.direct_link_without_redirect}
          onChange={handleDirectLinkSubdomainChange}
          enable={isUsingDirectLinkWithoutRedirectLanding}
          usageToggle={toggleDirectLinkWithoutRedirectLandingUsage}
          error={errors.directLinkLanding}
          innerRef={_alertRefs.directLinkLanding}
          checkDomain={checkDirectLinkWithoutRedirect}
          domainParking={domainParking}
          domainParkingToggle={domainParkingToggle}
          onDomianParkingInputChange={onDomianParkingInputChange}
          offerCategories={offer.categories}
        />
      )}

      <Card>
        <Card.Header className="no-padding card-header--with-tabs">
          {renderTabsControls(tabsControls, activeTab, setActiveTab)}
          {renderDropdown(tabsControls, activeTab, setActiveTab, dropdownOpen, toggleDropdown)}
        </Card.Header>

        <Card.Body className="no-padding">
          <TabContent activeTab={activeTab}>
            {panes.length > 0 &&
              panes.map((pane, index) => (
                <TabPane key={index} tabId={index + 1}>
                  {pane}
                </TabPane>
              ))}
          </TabContent>
        </Card.Body>
      </Card>

      <Row>
        <Col>
          <FormGroup className="text-center">
            <Button
              size="lg"
              color="primary"
              disabled={stream.offerId === 0 || loading || isUserBlocked}
            >
              {isEdit ? (
                <FormattedMessage id="flow.buttons.save" defaultMessage="Save a flow" />
              ) : (
                <FormattedMessage id="flow.buttons.create" defaultMessage="Create a flow" />
              )}
            </Button>
          </FormGroup>
        </Col>
      </Row>

      <AlertModal open={modal} message={message} onClose={toggleModal} />
      <IframeConstructorModal
        open={iframeConstructorModalOpen}
        toggle={toggleIframeConstructorModal}
        submit={handleIframeConstructorSubmit}
        settings={iframeConstructorSettings}
        link={getComputedLink(stream.link)}
      />

      <LandingFeaturesModal
        theme={3}
        isOpen={landingFeaturesModalOpen}
        toggle={landingFeaturesModalToggle}
        isCdn={isCdn}
        abTest={stream.abTest}
        selected={getSelectedFeaturesId(stream.features)}
        rawFeatures={stream.features}
        onABTestChange={handleChangeABTest}
        onFeatureChange={handleLandFeatureChange}
        landingsABTestEnabled={landingsABTestEnabled}
        transitsABTestEnabled={transitsABTestEnabled}
        streamEditable={stream.editable}
      />

      <TransitsFeaturesModal
        isOpen={transitsFeaturesModalOpen}
        toggle={transitsFeaturesModalToggle}
        disabled={
          !stream.editable ||
          !use_transit_service ||
          isUsingDirectLinkWithoutRedirectLanding ||
          domainParking.enabled
        }
        featuresList={stream.transitFeatures}
        toggleComebacker={handleTransitsComebackerChange}
        transit_comebacker={stream.transit_comebacker}
        handleTransitFeatureChange={handleTransitFeatureChange}
        handleNewsShowcaseSettingsChange={handleNewsShowcaseSettingsChange}
      />
    </Form>
  );
};

export default FlowForm;
